/* eslint eqeqeq: "off" */
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import LinearProgress from "@material-ui/core/LinearProgress";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { checkAndReplace } from "../../../../helpers/Formatter";

export function CampPointsDialog({ camps, show, setShow, setRefetch }) {
  const [isLoading, setIsLoading] = useState(false);
  const [studentPoints, setStudentPoints] = useState([]);

  // Get the camp ID - assuming you want the first active camp
  const campId = camps && camps.length > 0 ? camps[0].camp_id : null;

  // Ref to track if component is mounted
  const isMountedRef = React.useRef(true);

  const handlePointsChange = (index, newValue) => {
    if (!studentPoints) {
      return;
    }

    let studentsCopy = [...studentPoints];
    studentsCopy[index].adding = newValue === "adding" ? true : false;
    setStudentPoints(studentsCopy);
  };

  const savePoints = async () => {
    if (!campId || camps.length === 0) {
      console.error("No camp ID available");
      return;
    }

    if (!isMountedRef.current) return;
    setIsLoading(true);

    let transactionDate = moment(new Date()).format("YYYY-MM-DD");

    let finalPoints = studentPoints.map((sp, i) => {
      return { ...sp, comment: checkAndReplace(sp.comment) };
    });

    try {
      const res = await axios.post("/api/camps/points/", {
        camp_id: campId,
        date: transactionDate,
        points: finalPoints,
      });

      if (!isMountedRef.current) return;

      console.log("Points saved successfully:", res.data);

      // Trigger refetch in parent component if setRefetch is provided
      if (setRefetch) {
        setRefetch(true);
      }

      // Close the modal
      handleClose();
    } catch (error) {
      console.error("Error saving points:", error);
      alert("Failed to save points. Please try again.");
      // You might want to show an error message to the user here
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    }
  };

  const getPoints = async () => {
    if (!campId) {
      console.error("No camp ID available for fetching points");
      return;
    }

    if (!isMountedRef.current) return;
    setIsLoading(true);

    try {
      const response = await axios.get(`/api/camps/points/${campId}`);

      if (!isMountedRef.current) return;
      setStudentPoints(response.data.results);
    } catch (error) {
      console.error("Error fetching points:", error);
      if (isMountedRef.current) {
        setStudentPoints([]);
      }
    } finally {
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    }
  };

  const handleClose = () => {
    setShow(false);
    // Reset state when closing
    setStudentPoints([]);
  };

  useEffect(() => {
    if (show && campId) {
      getPoints();
    }
  }, [show, campId]);

  // Cleanup function to prevent memory leaks
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  // Don't render if no camp ID is available
  if (!campId) {
    return (
      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby="example-modal-sizes-title-lg"
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>No camp information available.</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      aria-labelledby="example-modal-sizes-title-lg"
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          Camp Points - {camps[0]?.camp_name || "Camp"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {isLoading ? (
          <LinearProgress color="secondary" style={{ width: "100%" }} />
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Student Name</TableCell>
                <TableCell>Current Points</TableCell>
                <TableCell colSpan={3}>Add/Remove Points</TableCell>
                <TableCell>Comment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {studentPoints && studentPoints.length > 0 ? (
                studentPoints.map((sp, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell>{sp.user_id}</TableCell>
                      <TableCell>{sp.firstname + " " + sp.lastname}</TableCell>
                      <TableCell>{sp.changed_grade}</TableCell>
                      <TableCell className="m-0 p-0">
                        <button
                          className={
                            "btn btn-elevate " +
                            (sp.adding ? "btn-success" : "btn-light")
                          }
                          onClick={() => {
                            handlePointsChange(index, "adding");
                          }}
                        >
                          +
                        </button>
                      </TableCell>
                      <TableCell className="m-0 p-0">
                        <button
                          className={
                            "btn btn-elevate " +
                            (sp.adding ? "btn-light" : "btn-danger")
                          }
                          onClick={() => {
                            handlePointsChange(index, "remove");
                          }}
                        >
                          -
                        </button>
                      </TableCell>
                      <TableCell className="m-0 p-0">
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Points"
                          min="0"
                          onChange={(e) => {
                            let newPoints = [...studentPoints];
                            newPoints[index].amount = isNaN(
                              parseInt(e.target.value)
                            )
                              ? 0
                              : parseInt(e.target.value);
                            setStudentPoints(newPoints);
                          }}
                        />
                      </TableCell>
                      <TableCell>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Comment"
                          onChange={(e) => {
                            let newPoints = [...studentPoints];
                            newPoints[index].comment = e.target.value;
                            setStudentPoints(newPoints);
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : studentPoints && studentPoints.length <= 0 ? (
                <TableRow>
                  <TableCell colSpan={7}>
                    No students found for this camp.
                  </TableCell>
                </TableRow>
              ) : null}
            </TableBody>
          </Table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-secondary"
          onClick={handleClose}
          disabled={isLoading}
        >
          Close
        </button>
        <button
          className="btn btn-primary"
          onClick={savePoints}
          disabled={isLoading || !studentPoints || studentPoints.length === 0}
        >
          {isLoading ? "Saving..." : "Save Points"}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
